import { Theme, css } from '@emotion/react';

import { ReactNode } from 'react';

import { Radius, Spacing } from 'chatie-design-system';

import { OnClickProps } from '../../utils/misc';

const selectableCSS =
  (isSelected: boolean, padding: number) => (theme: Theme) =>
    css`
      border-radius: ${Radius.small}px;
      padding: ${padding}px;
      cursor: pointer;

      ${isSelected
        ? css`
            border: 1px solid ${theme.colors.main500};
            background-color: ${theme.colors.main50};
          `
        : css`
            border: 1px solid ${theme.border.light};
          `}
    `;

type Props = {
  selected?: boolean;
  pad?: number;
  children?: ReactNode;
};

const Selectable = ({
  selected = false,
  pad = Spacing.medium,
  children,
  onClick,
}: Props & OnClickProps) => {
  return (
    <div css={selectableCSS(selected, pad)} onClick={onClick}>
      {children}
    </div>
  );
};

export default Selectable;
